export default "__VITE_ASSET__C0T_3DSK__"